var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Have you locked your rate?"}},[_c('input-radio-boolean',{attrs:{"name":"have_you_locked_your_rate","value":_vm.mortgage.have_you_locked_your_rate,"true":"Yes","false":"No","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }